var watchlistSelector = {
	label: "Seleziona Watchlist",
	validationErrors: {
		selectWatchlist: "Devi selezionare una watchlist"
	}
};
var it = {
	watchlistSelector: watchlistSelector
};

export { it as default, watchlistSelector };
